export var isExperimentOn = function (experiments, experimentName) {
    var val = experiments[experimentName];
    return typeof val === 'string' ? val === 'true' : !!val;
};
export var getExperimentValue = function (experiments, experimentName, defaultValue) {
    var val = experiments[experimentName];
    if (val === undefined) {
        return defaultValue;
    }
    return val;
};
